import { redirect } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import { login, validateShopifySession } from "~/shopify.server";
import { t, useTranslations } from "~/translations/utils";
import bulmaCustom from "~/css/bulma-custom.css?url";
import { Navbar } from "~/components/Navbar";
import { Footer } from "~/components/Footer";
import { Features } from "./Features";
import { UnauthorizedRequestModal } from "./UnauthorizedRequestModal";
import { useState } from "react";
import logiveryLogo from "~/assets/images/logivery-logo.svg";
import lunaCustomerSupport from "~/assets/images/luna-customer-support.svg";

export const MetaTranslations = () => {
  useTranslations();
  return {
    title: t("landing.title"),
    description: t("landing.description"),
  };
};

export const meta = () => {
  const metaTranslations = MetaTranslations();
  return [
    { title: metaTranslations.title },
    {
      name: "description",
      content: metaTranslations.description,
    },
  ];
};

export const links = () => [
  {
    rel: "stylesheet",
    href: bulmaCustom,
  },
];

export const loader = async ({ request }) => {
  const { session } = await validateShopifySession(request);

  const url = new URL(request.url);

  if (url.searchParams.get("shop")) {
    throw redirect(`/app?${url.searchParams.toString()}`);
  }

  const isUnauthorizedRequest = url.searchParams.get("unauthorized") ?? false;

  return {
    showForm: Boolean(login),
    appMode: session != null,
    isUnauthorizedRequest,
  };
};

export default function App() {
  useTranslations();

  const { appMode, isUnauthorizedRequest } = useLoaderData();

  const [modalOpen, setModalOpen] = useState(isUnauthorizedRequest && !appMode);
  const handleToggleModalOpen = (value = null) => {
    setModalOpen(value ?? !modalOpen);
  };

  return (
    <div className={"has-navbar-fixed-bottom"}>
      <Navbar appMode={appMode} />

      <div className="py-5">
        <div className="hero">
          <h1 className="is-hidden subtitle has-text-centered">
            {t("landing.title")}
          </h1>
          <div className="hero-body is-flex is-justify-content-center">
            <div style={{ width: "30rem", height: "7.5rem" }}>
              <figure className={`image is-4by1`}>
                <img src={logiveryLogo} alt="Logivery" />
              </figure>
            </div>
          </div>
        </div>

        <Features />

        <div className="section container has-text-centered">
          <div className="">
            <figure className="image is-inline-block">
              <img
                src={lunaCustomerSupport}
                alt="Customer Support"
                style={{ height: "320px" }}
              />
            </figure>
            <article className="container" style={{ maxWidth: "50rem" }}>
              <p>{t("landing.integrations")}</p>
            </article>
          </div>
        </div>
      </div>

      <Footer />

      <UnauthorizedRequestModal
        open={modalOpen}
        toggleOpen={handleToggleModalOpen}
      />
    </div>
  );
}
